export default __webpack_public_path__ + "ba90d6df41d18c8a45761afcab40da05.png";